// theirs
import { motion } from 'framer-motion'
import classNames from 'classnames'

// ours
import { ContentDataModel } from '../../../interfaces'
import {
    splitTitleAndTextAndImageBaseClass,
    StyledSplitTitleAndTextAndImage,
} from './style'
import { animationVariants } from '../../../animations'

export interface SplitTitleAndTextAndImageProps {
    className?: string
    testId?: string
    content: ContentDataModel
    animationControls?: any
}

const SplitTitleAndTextAndImage = ({
    className,
    testId,
    content,
    animationControls,
}: SplitTitleAndTextAndImageProps) => {
    return (
        <StyledSplitTitleAndTextAndImage
            className={classNames(
                splitTitleAndTextAndImageBaseClass,
                className
            )}
            data-testid={testId}
            content={content}
        >
            <motion.div
                variants={animationVariants.splitContainerFirst}
                initial="hidden"
                animate={animationControls}
                className="content-first"
            >
                <div className="content-outer">
                    <div className="content-inner">
                        {content.contentTitle && (
                            <div className="title-wrapper">
                                <h2>{content.contentTitle}</h2>
                            </div>
                        )}
                        {content.contentText && (
                            <div className="text-wrapper">
                                <p>{content.contentText}</p>
                            </div>
                        )}
                    </div>
                </div>
            </motion.div>
            <motion.div
                variants={animationVariants.splitContainerSecond}
                initial="hidden"
                animate={animationControls}
                className="content-second"
            >
                <div className="content-outer">
                    <div className="content-inner">
                        {content.contentSecondTitle && (
                            <div className="title-wrapper">
                                <h2>{content.contentSecondTitle}</h2>
                            </div>
                        )}
                        {content.contentSecondText && (
                            <div className="text-wrapper">
                                <p>{content.contentSecondText}</p>
                            </div>
                        )}
                    </div>
                </div>
            </motion.div>
        </StyledSplitTitleAndTextAndImage>
    )
}

export default SplitTitleAndTextAndImage
